export const booleanToString = (value: boolean) => String(Number(value))
export const stringToBoolean = (value: string) => Boolean(Number(value))
export const stringToNumber = (value: string) => {
  if (value === '') {
    return null
  }
  const number = Number(value)
  return isNaN(number) ? null : number
}
export const stringToFile = (str: string, fileName: string, mimeType: string = 'image/jpeg') => {
  try {
    const byteCharacters = atob(str)

    const byteNumbers = new Array(byteCharacters.length)
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i)
    }
    const byteArray = new Uint8Array(byteNumbers)

    return new File([byteArray], fileName, { type: mimeType })
  } catch (error) {
    console.error(error)
    return null
  }
}
export const base64ToBlob = (
  base64: string,
  contentType: string = '',
  sliceSize: number = 512
): Blob => {
  const byteCharacters = atob(base64)
  const byteArrays = []

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize)

    const byteNumbers = new Array(slice.length)
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }

    const byteArray = new Uint8Array(byteNumbers)
    byteArrays.push(byteArray)
  }

  return new Blob(byteArrays, { type: contentType })
}
export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = () => {
      const base64String = reader.result as string
      resolve(base64String.split(',')[1])
    }

    reader.onerror = (error) => {
      reject(error)
    }

    reader.readAsDataURL(file)
  })
}

export const camelCase2kebabCase = (text: string) => {
  return text.replace(/[A-Z]/, (a) => `-${a.toLowerCase()}`)
}
